  /**
    * ControllerStepStack
    * 
    * A utility controller to manage a stack-like data structure of visited steps.
    * It tracks the current step, previous steps, and provides methods to navigate forward 
    * and backward through the steps.
  */
  class ControllerStepStack {
    constructor(store) {
      this.store = store;
      //this.nextClickHandler = this.nextClickHandler.bind(this);  // Bind the method to the current instance.
    }

    goToStep(stepId, selectedValue) {
      this.store.dispatch({ type: 'GO_TO_STEP', payload: stepId });

      if(this.getCurrentStep() === 'eby-sub4-plan'){
        document.querySelector('#eby-subs-goBack').style.display = 'none';
      } else {
        document.querySelector('#eby-subs-goBack').style.display = 'block';
      }

      const currentState = this.store.getState();
      if(stepId){
        MetricsMainFunnel.nextSectionFunnel(selectedValue, stepId , currentState.boxType);
      }
    }

    getCurrentStep() {
      return this.store.getState().currentStep;
    }

    goBack(planInstance) {
      const currentSteps = this.store.getState().stepsVisited;
      if(currentSteps.length === 1 && !currentSteps.includes('eby-sub4-plan')){
        console.log(`----------------------------------------------------------------------------------------------------`);
        console.error("The first component was removed and the funnel shouldn't be working check stepsVisited", currentSteps);
        console.log(`----------------------------------------------------------------------------------------------------`);
        this.handleCloseButtonClickEvent()
      }
      if (currentSteps.length < 2) {
          throw new Error("Can't go back, already at the first step.");
      }

      this.store.dispatch({ type: 'GO_BACK' });
      
      const updatedState = this.store.getState();
      //ControllerElementStyle.hideElementTriggered(updatedState.currentStep);

      if (updatedState.currentStep === 'eby-sub4-plan') {
          document.querySelector('#eby-subs-goBack').style.display = 'none';
      }
      if (updatedState.currentStep === 'eby-sub4-size-panty-bra' || updatedState.currentStep === 'eby-sub4-size-bra') {
        this.resetSetsGrid(updatedState);
      }
    }

    resetSetsGrid(updatedState){
      // Logic to reset size elements and update the store.
      this.store.dispatch({ type: 'RESET_SIZES' });
      UseCaseStyling.resetSizesCustom(updatedState.currentStep);
      document.querySelector('#custom-box-grid-setBraOnly').classList.remove('hide');
      document.querySelector('#custom-box-grid-setPantyOnly').classList.add('hide');

      const setGridBraElements = document.querySelectorAll('#custom-box-insert-all-bra-set-here .eby-subs-custom-box-grid-item');
      const setGridPantyElements = document.querySelectorAll('#custom-box-insert-all-bra-set-panty-here .eby-subs-custom-box-grid-item');
  
      setGridBraElements.forEach(el => el.setAttribute('data-prodvarid', 'undefined') );
      setGridPantyElements.forEach(el => el.setAttribute('data-prodvarid', 'undefined') );
    }
    
    nextClickHandler(nextComponentId) {
        ControllerComponent.hideComponent(this.getCurrentStep());
        ControllerComponent.showComponent(nextComponentId);
        
        this.store.dispatch({ type: 'GO_TO_STEP', payload: nextComponentId });
        if (vela.subFour.currentStep.indexOf('custom') >= 0) {
          this._updateAllCustomBoxOptions();
        }
    }

    goNext(nextComponentId) {
        this.removeGoNextListener(); // remove any existing listeners
        console.log("Listener removed. About to add a new one.", nextComponentId);
        this.nextClassSelector = document.querySelector(`#${this.getCurrentStep()} .controllerNextButton`);

        // Binding the function to ensure we can remove it later.
        this.boundNextClickHandler = this.nextClickHandler.bind(this, nextComponentId);

        console.log("Adding new listener.", nextComponentId);
        this.nextClassSelector.addEventListener('click', this.boundNextClickHandler);
        
        // Update pagination UI when moving to the next step
        //this.updatePaginationUi.updateFromState();
        
    }
    
    removeGoNextListener() {
        if (this.nextClassSelector && this.boundNextClickHandler) {
            console.log("Attempting to remove listener.");
            this.nextClassSelector.removeEventListener('click', this.boundNextClickHandler);
            console.log("Listener should be removed now.");
        }
    }
   

    handleCloseButtonClickEvent(){        
        const wrapper = document.getElementById('subsc40-wrapper');
        if (wrapper) {
            wrapper.style.display = 'none';
        } else {
            console.error('Wrapper element not found.');
        }

        const currState = this.store.getState();
        const elementHide = document.querySelector(`#${currState.currentStep}`);
        if (elementHide) {
            elementHide.classList.add('hide');
        } else {
            console.error('Element to hide not found.');
        }

        const initialElement = document.querySelector('#eby-sub4-plan');
        if (initialElement) {
            initialElement.classList.remove('hide');
        } else {
            console.error('Initial element not found.');
        }
        
        this.store.dispatch({ type: 'RESET_STEP' });
        this.store.dispatch({ type: 'RESET_BOX_TYPE' });
        this.store.dispatch({ type: 'RESET_SIZES' });
        this.store.dispatch({ type: 'RESET_CBOPTS' });
        this.store.dispatch({ type: 'RESET_PRODUCTS' });
        UseCaseStyling.removeAllHighlights();

        MetricsMainFunnel.closeFunnel(currState.currentStep, currState.boxType);
    }

    _updateAllCustomBoxOptions() {
      //console.log(':: _updateAllCustomBoxOptions running ::');
      // pull custom box options and run stock check for sizes
      _initPreloader(true);
      _getProducts(vela.subFour).then((stockCheckedProdsForSub) => {
        //
        console.log(":: custom box options stock check in process... ::");
        
        // get children products to add
        let curatedMembershipProds = stockCheckedProdsForSub;
  
        console.log(':: products to check ::', {
          prods: stockCheckedProdsForSub
        });

        this.store.dispatch({
          type: 'SET_CBOPTS',
          payload: stockCheckedProdsForSub[0]
        });

        // get all current custom box elems
        let customBoxElems = document.querySelectorAll('.eby-subs-custom-box-grid-item');
        stockCheckedProdsForSub[0].prodInventoryData.map((stockedItem) => {
          if (stockedItem.availQty >= 9) {
            //console.log(":: stock check pass - variant updated with size appropriate one :: ", stockedItem.prodTitle);
            let elems = document.querySelectorAll(".eby-subs-custom-box-grid-item[data-prodid='"+ stockedItem.prodId +"']");
            if (!!elems) {
              elems.forEach((el) => {
                //console.log(':: stock variant id updated ::', {vid: stockedItem.variantId, title: el.getAttribute('data-prodname')});
                el.setAttribute('data-prodvarid', stockedItem.variantId);
              });
            }
          }
        });
        // document.querySelectorAll('.eby-subs-custom-box-grid-item')[0].setAttribute('data-prodvarid', )
        _initPreloader(false);
        const filterStyle = new FilterGrid(this.store);
        filterStyle.updateFilter();
        filterStyle.updateFilterSet();
      });

    }

  }
  /**
    * The UiSubscription class is the main UI controller responsible for managing 
    * the user's interactions and navigation throughout the subscription process.
  */
  class UiSubscription {
    /**
      * Initializes the main UI controller.
      * 
      * @param {Array} stepsArr - An array defining the steps and their behaviors in the UI flow.
    */
    constructor(stepsArr) {
      this.isSetupCalled = false;
      this.initializeStore();
      this.initializeControllers();
      this.bindMethods();
      this.handleInitialSetup(stepsArr);
    }

    initializeStore(){
      this.store = new EbySubscriptionStore(inistialStoreState, rootReducer);
      this.stepTracker = new ControllerStepStack(this.store);
    }

    initializeControllers(){
      this.planSelectionController = new PlanSelectionController(this.stepTracker, this.store);
      this.summaryController = new SummaryController();
      this.styleSelectionController = new StyleSelectionController(this.stepTracker, this.store);
      this.sizeSelectionController = new SizeSelectionController(this.stepTracker, this.store);
      this.colorSelectionController = new ColorSelectionController(this.stepTracker, this.store, this.summaryController);
      this.customHandlerController = new CustomHandlerController(this.stepTracker, this.store, this.summaryController);
    }

    bindMethods(){
      //this.handleCloseButton = this.handleCloseButton.bind(this);
      this.handleCloseButtonClickEvent = this.handleCloseButtonClickEvent.bind(this);
      this.handleGoBackClickEvent = this.handleGoBackClickEvent.bind(this);
    }

    handleInitialSetup(stepsArr) {
      this.stepsArr = stepsArr;
      this.initFirstStep("eby-sub4-plan");
      this.handleGoBackClicked('eby-subs-goBack');
      this.handleCloseButton();
    }

    initFirstStep(firstStepId) {
      this.stepTracker.goToStep(firstStepId);
      if(this.stepTracker.getCurrentStep() === 'eby-sub4-plan'){
        document.querySelector('#eby-subs-goBack').style.display = 'none';
      }
    }

    handleGoBackClicked(backButtonId) {
      document.getElementById(backButtonId).addEventListener('click', this.handleGoBackClickEvent);
    }

    handleGoBackClickEvent(event){
      ControllerComponent.hideComponent(this.stepTracker.getCurrentStep());
      this.stepTracker.goBack();
      ControllerComponent.showComponent(this.stepTracker.getCurrentStep());
    }

    handleLandingPage(targetId, nextComponentId){
      ControllerComponent.hideComponent(this.stepTracker.getCurrentStep())
      ControllerComponent.showComponent(nextComponentId);
      
      let planSelected = '';
      switch(nextComponentId){
        case 'subs-plan-001':
          planSelected = 'classic_box';
          break;
        case 'eby-sub4-style-panty-bra-only':
          planSelected = 'bra_box';
          break;
        case 'eby-sub4-size-panty-bra':
          planSelected = 'set_box';
          this.handleStyleClickEvent();
          break;

        default:
          console.error('Clicked button from a collection page but no plan selection was found, ', nextComponentId);
      }
      
      this.store.dispatch({ type: 'RESET_SET_BRA_OPT' });
      // Instead of directly setting properties, dispatch actions
      this.store.dispatch({
        type: 'SET_BOX_TYPE',
        payload: {boxType: planSelected, currentBox:planSelected}  
      });
      this.store.dispatch({
        type: 'RESET_PRODUCTS',
        payload: {boxType: planSelected, currentBox:planSelected}  
      });

      this.stepTracker.goToStep(nextComponentId);
    }

    handleStyleClickEvent() {
      
        const productControllerSet = new ControllerCustomProduct(window.location.origin + '/collections/test-custom-set-subscription/products.json?limit=200', 'custom-box-insert-all-bra-set-here', this.store);
        const productControllerSetPanty = new ControllerCustomProduct(window.location.origin + '/collections/test-custom-set-subscription/products.json?limit=200', 'custom-box-insert-all-bra-set-panty-here', this.store);
        productControllerSet.renderProductsSet();  
        productControllerSetPanty.renderProductsSetPanty();

        this.store.dispatch({
          type: 'SET_STYLES',
          payload: "set_custom"
        });
    }

    handleCloseButton(){
      // Attach the event listener directly; no binding needed for this method
      const closeButton = document.getElementById('subsc40-close23');
      if (closeButton) {
          closeButton.addEventListener('click', this.handleCloseButtonClickEvent);
      } else {
          console.error('Close button not found.');
      }
    }

    resetSetsGrid(updatedState){
      // Logic to reset size elements and update the store.
      this.store.dispatch({ type: 'RESET_SIZES' });
      UseCaseStyling.resetSizesCustom(updatedState.currentStep);
      document.querySelector('#custom-box-grid-setBraOnly').classList.remove('hide');
      document.querySelector('#custom-box-grid-setPantyOnly').classList.add('hide');
      document.querySelector('#set-box-cu-slot_one').classList.remove('hidden');
      document.querySelector('#set-box-cu-slot_two').classList.add('hidden');

      const setGridBraElements = document.querySelectorAll('#custom-box-insert-all-bra-set-here .eby-subs-custom-box-grid-item');
      const setGridPantyElements = document.querySelectorAll('#custom-box-insert-all-bra-set-panty-here .eby-subs-custom-box-grid-item');
  
      setGridBraElements.forEach(el => el.setAttribute('data-prodvarid', 'undefined') );
      setGridPantyElements.forEach(el => el.setAttribute('data-prodvarid', 'undefined') );
    }

    handleCloseButtonClickEvent(){        
        const wrapper = document.getElementById('subsc40-wrapper');
        if (wrapper) {
            wrapper.style.display = 'none';
        } else {
            console.error('Wrapper element not found.');
        }

        const currState = this.store.getState();
        const elementHide = document.querySelector(`#${currState.currentStep}`);
        if (elementHide) {
            elementHide.classList.add('hide');
        } else {
            console.error('Element to hide not found.');
        }

        const initialElement = document.querySelector('#eby-sub4-plan');
        if (initialElement) {
            initialElement.classList.remove('hide');
        } else {
            console.error('Initial element not found.');
        }

        this.resetSetsGrid(currState);
        this.store.dispatch({ type: 'RESET_STEP' });
        this.store.dispatch({ type: 'RESET_BOX_TYPE' });
        this.store.dispatch({ type: 'RESET_SIZES' });
        this.store.dispatch({ type: 'RESET_CBOPTS' });
        this.store.dispatch({ type: 'RESET_PRODUCTS' });
        UseCaseStyling.removeAllHighlights();

        MetricsMainFunnel.closeFunnel(currState.currentStep, currState.boxType);
    }
    
    setupSteps() {
      this.stepsArr.forEach((steps, i) => {
        steps.forEach(step => {
          switch(step.type) {
            case 'planSelection':
              this.planSelectionController.handlePlanSelection(step.clickedId, step.nextComponentId);
              break;
            case 'styleSelection':
              this.styleSelectionController.handleStyleSelection(step.clickedId, step.nextComponentId);
              break;
            case 'sizeSelectionBra':
              this.sizeSelectionController.handleSizeSelectionCustomBra(step.sizeSelect, step.sizeParent, step.containerId, step.nextComponentId);
              break;
            case 'sizeSelection':
              this.sizeSelectionController.handleSizeSelection(step.sizeSelect, step.sizeParent, step.containerId, step.nextComponentId);
              break;
            case 'sizePantySelection':
              this.sizeSelectionController.handleSizePantySelection(step.sizeSelect, step.sizeParent, step.containerId, step.nextComponentId);
              break;
            case 'sizeSetSelection':
            this.sizeSelectionController.handleSizeSetSelection(step.sizeSelect, step.sizeParent, step.containerId, step.nextComponentId);
              break;
            case 'colorSelection':
              this.colorSelectionController.handleColorSelection(step.clickedId, step.nextComponentId);
              break;
            case 'productSelection':
              this.customHandlerController.handleProductSelection(step.productSelectClass, step.containerId, step.nextComponentId); 
              break;
            case 'productSelectionBra':
              this.customHandlerController.handleProductSelectionBra(step.productSelectClass, step.containerId, step.nextComponentId); 
              break;
            case 'productSelectionSet':
              this.customHandlerController.handleProductSelectionSet(step.productSelectClass, step.containerId, step.nextComponentId); 
              break;
            case 'customSummary':
              this.customHandlerController.handleProductRemoveToSummary(step.clickedId, step.nextComponentId); 
              break;
            default:
              console.error(`Unknown step type: ${step.type}`);
          }
        });
      });
    }
  
    // not sure why this is here 
    goBack() {
      ControllerComponent.hideComponent(this.stepTracker.getCurrentStep());
      this.stepTracker.goBack();
      ControllerComponent.showComponent(this.stepTracker.getCurrentStep());
    }
  }

  let uiFunnelInstance = null;

  function mainSubscriptionFunnel(openLandingPage, returnFlag){
    /*
      ****************************************************************
      * CURATED BRA FLOW
      ****************************************************************
    */
    let classicBraFlowSteps = [
      // { type: 'planSelection', clickedId: 'eby-subs-plan-classic', nextComponentId: 'subs-plan-001' },
      { type: 'planSelection', clickedId: '.dataGroupComponent', nextComponentId: '.ebySubsAllPlans23 ' },
      { type: 'colorSelection', clickedId: 'eby-sub-color-spicy', nextComponentId: 'eby-sub4-summary' },
      { type: 'colorSelection', clickedId: 'eby-sub-color-bold', nextComponentId: 'eby-sub4-summary' },
      { type: 'colorSelection', clickedId: 'eby-sub-color-sophisticated', nextComponentId: 'eby-sub4-summary' }
    ];
    /*
      ****************************************************************
      * CURATED PANTY FLOW
      ****************************************************************
    */
    let classicPantyFlowSteps = [
      { type: 'styleSelection', clickedId: '.ebySubsStyle-001', nextComponentId: '.ebySubsStyle-001-1' },
      { type: 'styleSelection', clickedId: '.ebySubsStyle-002', nextComponentId: '.ebySubsStyle-002-2' },


      { type: 'sizePantySelection', sizeSelect: ['.size-panty-custom-box-select'], sizeParent: ['.styleBoxSizePantyCustom'],  containerId: 'subs-size-01', nextComponentId: 'eby-sub4-custom-box-product' },
      //{ type: 'sizePantySelection', sizeSelect: ['.size-panty-select'], sizeParent: ['.styleBoxSizePanty'], containerId: 'eby-sub4-size-panty', nextComponentId: 'eby-sub4-color' },
    ];
    /*
      ****************************************************************
      * CUSTOM BOX FLOW
      ****************************************************************
    */
    let classicPantyCustomBoxFlowSteps = [
      { type: 'productSelection', productSelectClass: '.eby-subs-custom-move-itemin-box', containerId: 'eby-sub4-custom-box-product', nextComponentId: 'eby-sub4-custom-box-list-pds' },
      { type: 'customSummary', clickedId: 'eby-subs-custom-box-next-bttn23', nextComponentId: 'eby-sub4-summary' },
      { type: 'customSummary', clickedId: 'eby-subs-custom-box-bra-next-bttn23', nextComponentId: 'eby-sub4-summary' },
      { type: 'customSummary', clickedId: 'eby-subs-custom-box-set-next-bttn23', nextComponentId: 'eby-sub4-summary' },
      ];
    /*
      ****************************************************************
      * SET FLOW
      ****************************************************************
    */
    let braFlowSteps = [
       { type: 'styleSelection', clickedId: '.ebySubsStyle-003', nextComponentId: '.ebySubsStyle-003-3' },
      { type: 'styleSelection', clickedId: '.ebySubsStyle-004', nextComponentId: '.ebySubsStyle-004-4' },
      { type: 'sizeSelection', sizeSelect: ['.flexible-size-boxes-bra'], sizeParent: ['.styleBoxSizeCup', '.styleBoxCupBra'], containerId: 'eby-sub4-size-bra', nextComponentId: 'eby-sub4-custom-box-product-one-bra' },
      { type: 'sizeSelection', sizeSelect: ['.flexible-size-boxes-bra'], sizeParent: ['.styleBoxSizeCup', '.styleBoxCupBra'], containerId: 'eby-sub4-size-bra-surpise', nextComponentId: 'eby-sub4-color' },
    ];
    /*
      ****************************************************************
      * PREMIUM FLOW
      ****************************************************************
    */
    let premiumFlowSteps = [

      { type: 'styleSelection', clickedId: '.ebySubsStyle-005', nextComponentId: '.ebySubsStyle-005-5' },
      { type: 'styleSelection', clickedId: '.ebySubsStyle-006', nextComponentId: '.ebySubsStyle-006-6' },
      { type: 'styleSelection', clickedId: '.ebySubsStyle-007', nextComponentId: '.ebySubsStyle-007-7' },
      
      { type: 'productSelectionBra', productSelectClass: '.eby-subs-custom-move-itemin-box', containerId: 'eby-sub4-custom-box-product-one-bra', nextComponentId: 'eby-sub4-custom-box-list-bra' },
      { type: 'productSelectionSet', productSelectClass: '.eby-subs-custom-move-itemin-box', containerId: 'eby-sub4-custom-box-product-set', nextComponentId: 'eby-sub4-custom-box-list-set' },
      { type: 'sizeSetSelection', sizeSelect: ['.size-bra-panty-select', '.size-panty-set-select'], sizeParent: ['.styleBoxSizeCupSet', '.styleBoxCupBraSet', '.styleBoxSizePantySet'], containerId: 'eby-sub4-size-panty-bra', nextComponentId: 'eby-sub4-color' },
      //{ type: 'sizeSetSelection', sizeSelect: ['.size-bra-panty-select', '.size-panty-set-select'], sizeParent: ['.styleBoxSizeCupSet', '.styleBoxCupBraSet', '.styleBoxSizePantySet'], containerId: 'eby-sub4-size-panty-bra-custom', nextComponentId: 'eby-sub4-custom-box-product-set' },
    ];

    function subsHandleSizeGuide(){
      const subsAllSizeGuide = document.querySelectorAll('.eby-subs-openSizeGuide');
      const mainSizeGuideWrapper = document.querySelector('#eby-subs-wrapperAllSizeGuide');

      function handleSizeGuideBra(event){

        const guideDataSet = event.target.dataset.guide;

        if(guideDataSet){
          mainSizeGuideWrapper.classList.remove('hide');
          subsHandleSizeGuideClose(mainSizeGuideWrapper, guideDataSet);
          handleSizeGuideShow(guideDataSet, 'show');
        }
      }

      subsAllSizeGuide.forEach(elem => elem.addEventListener('click', handleSizeGuideBra));
    }

    function subsHandleSizeGuideClose(sizeGuideElem, type){
      const subsAllSizeGuideClose = document.querySelector('#eby-subs-SizeGuideCloseButton');
      
      subsAllSizeGuideClose.addEventListener('click', (event) => {

        if(sizeGuideElem){
          sizeGuideElem.classList.add('hide');
          handleSizeGuideShow(type, 'hide');
        }
      })
    }

    function handleSizeGuideShow(type, style){

      const sizeGuideElem = document.querySelector(`#eby-subs-sizeChart-${type}`);
      
      if(sizeGuideElem && (style === 'show')){
        sizeGuideElem.classList.remove('hide');
      } else if(sizeGuideElem && (style === 'hide')){
        sizeGuideElem.classList.add('hide');
      }else {
        console.error('The type of chart selected does not exist for -> ', type);
      }
    }
    if (!uiFunnelInstance) {
      
      uiFunnelInstance = new UiSubscription(
        [classicBraFlowSteps, classicPantyFlowSteps, classicPantyCustomBoxFlowSteps, braFlowSteps, premiumFlowSteps]
      );
      subsHandleSizeGuide();
    }

    return uiFunnelInstance;
  }

  /**
   *   Open helper guides like member box, about 1 panty, about 1 bra ...
  */
  linkHelpersGuides();
  function linkHelpersGuides(){
    
    initHelperClicks();
    closeHelper();

    function closeHelper(){

      const closeElement = document.querySelectorAll('.subsCloseButtonHelper');
      closeElement.forEach( el => {
        el.addEventListener('click', function(event){
          const elemClose = event.target.dataset.closeit;
          document.querySelector('#' + elemClose).classList.add('hide');
        })
      })
    }

    function initHelperClicks(){

      const allHelperLinks = document.querySelectorAll('.allSubsHelperLinks');
      allHelperLinks.forEach( el => el.addEventListener('click', openHelper) );
    }

    function openHelper(event){

      const type = event.target.dataset.helper;
      document.querySelector('#' + type).classList.remove('hide');
    }
  }

  function _initCloseHelper(){
      const closeElement = document.getElementById('subsc40-close23');
      closeElement.click();
  }

  function _isMissySizeGroup(sizeGroupVal) {
      let mSizeGroup = ['xs','sm','md','lg','xl'];
      return (mSizeGroup.indexOf(sizeGroupVal) >= 0);
  }
  async function getProdSellingPlanData(handle) {
    const url = window.Shopify.routes.root + "products/" + handle + ".js";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
  
      const json = await response.json();
      //console.log(json);
      return json;
    } catch (error) {
      console.error(error.message);
      //return json;
    }
  }
  // [{},{},{},{}]
  function addBoxToCart(boxData) {
      
      let membershipBoxProdsToAdd = "";
      const boxTypeRequested = this.boxRequestType;
      let self = this;
      _initPreloader(true);
      
      if (boxData.styles.indexOf("custom") >= 0) {
        membershipBoxProdsToAdd = _curateProducts(boxData.cbopts[0].prodInventoryData, [0]);
        getProdSellingPlanData(membershipBoxProdsToAdd[0].handle).then((data) => {
          membershipBoxProdsToAdd[0].selling_plan = data.selling_plan_groups[0].selling_plans[0].id;
          addToCartMainBlock(boxData, membershipBoxProdsToAdd);
        });
      } else {
        // get collection for given box
        _getProducts(boxData).then((stockCheckedProdsForSub) => {
          membershipBoxProdsToAdd = _curateProducts(stockCheckedProdsForSub[0].prodInventoryData, stockCheckedProdsForSub[0].originalCollListing);
          getProdSellingPlanData(membershipBoxProdsToAdd[0].handle).then((data) => {
            membershipBoxProdsToAdd[0].selling_plan = data.selling_plan_groups[0].selling_plans[0].id;
            addToCartMainBlock(boxData, membershipBoxProdsToAdd);
          });        
        });
      }
  }

  function addToCartMainBlock(boxData, membershipBoxProdsToAdd){
    const sizeBoxTitles = nameSizePantyBra(boxData);
        
        let currentBoxisCustomBox = '';
        let currentBoxFreq = '';

        if(boxData.currentBox){
          currentBoxisCustomBox = boxData.styles.includes('custom') ? 'Choose My Own' : '';

          if( boxData.styles.includes('set_custom')){
            currentBoxFreq = boxData.currentBox.description.split(' ').slice(0, 3).join(' ');
          } else {
            currentBoxFreq = boxData.currentBox.description.split(' ').slice(0, 2).join(' ');
          }
          
        }
        
        let membershipProperties = {
          '_tiertwo_sub_price_enabled' : "true",
          'Shipping Option' : "pickup Subscription WH",
          '_product_type' : 'Main Subscription',
          '_shipping_interval_unit_type' : "month",
          "_box_pref" : membershipBoxProdsToAdd[0].prodTitle + " - " + membershipBoxProdsToAdd[0].prodVarTitle,
          "_box_measurements" : membershipBoxProdsToAdd[0].prodVarTitle + " - " + membershipBoxProdsToAdd[0].braMeasurements,
          "_box_styles" : membershipBoxProdsToAdd[0].stylePref,
          "_box_colors" : membershipBoxProdsToAdd[0].colorPallet,
          "_box_v4_color":  boxData.colors,
          "_box_v4_sizes": sizeBoxTitles,
          "_box_v4_renews": boxData.currentBox.renewalPrice,
          "_box_v4_isCustom": currentBoxisCustomBox,
          "_box_v4_freq": currentBoxFreq,
          "_box_perk" : membershipBoxProdsToAdd[0].prodTitle,
          "_perk_key" : vela.subFour.boxRequestType,
          "_shipping_interval_frequency" : 3,
          "_subs_version": "4.0",
          "_tierfour_sub_price" : +membershipBoxProdsToAdd[0].prodPrice / 2/* may want to use sale price */
        };
        
        function nameSizePantyBra(boxData){
          let outSizeName = '';

          if(boxData.boxType === 'classic_box' && boxData.currentBox.box !== "class_box_bra"){
            outSizeName =  `${boxData.sizes.panty} (${boxData.sizes.pantyMeasure})`;
          } else if (boxData.boxType === 'classic_box' && boxData.currentBox.box === "class_box_bra"){
            outSizeName = `${boxData.sizes.braSizeChar} (${boxData.sizes.braCup + boxData.sizes.braMeasure})`;
          } else if (boxData.boxType === 'bra_box'){
            outSizeName = `${boxData.sizes.braSizeChar} (${boxData.sizes.braCup + boxData.sizes.braMeasure})`;
          } else if (boxData.boxType === 'set_box'){
            const pantyOnSize =  `${boxData.sizes.panty} (${boxData.sizes.pantyMeasure})`;
            outSizeName = `${boxData.sizes.braSizeChar} (${boxData.sizes.braCup + boxData.sizes.braMeasure}) / ${pantyOnSize}`;
          } else {
            outSizeName =  `${boxData.sizes.panty} (${boxData.sizes.pantyMeasure})`;
          }
          return outSizeName
        }
        
        let membershipFinalPrdIds = [];
        let membershipFinalPrds = [];
        
        if (vela.subFour.boxRequestType === "cc:cu" || vela.subFour.styles.indexOf('custom') >= 0) {
          membershipFinalPrds = membershipBoxProdsToAdd.reduce(function(acc, item) {
            let properties = {
              "_included_in_custombox":true,
              "Shipping Option":"pickup Ecommerce WH"
            };
            membershipFinalPrdIds.push(item.variantId);
          
            acc.push({
              quantity: 1, id: +item.variantId, properties: properties
            });
          
            return acc;
          },[]);
        } else {
          membershipFinalPrds = membershipBoxProdsToAdd.reduce(function(acc, item) {
            let properties = {
              "_included_in_membershipbox":true,
              "_product_type":"Sub Subscription",
              "Shipping Option":"pickup Subscription WH"
            };
            membershipFinalPrdIds.push(item.variantId);
          
            acc.push({
              quantity: 1, id: +item.variantId, properties: properties
            });
          
            return acc;
          },[]);
        }
        
        membershipProperties['_subscription_ids'] = membershipFinalPrdIds.join(',');
        
        let membershipBoxData = {
          attributes : {"has_curated_membership" : "true"},
          items: [
            {quantity: 1, id: membershipBoxProdsToAdd[0].variantId, properties: membershipProperties, selling_plan: membershipBoxProdsToAdd[0].selling_plan}
          ]
        };

        membershipBoxData.items = membershipBoxData.items.concat(membershipFinalPrds.slice(1,membershipFinalPrds.length)).reverse();

        const collapsedItems = membershipBoxData.items.reduce((accumulator, currentItem) => {
          // Check if the id exists in the accumulator
          if (accumulator[currentItem.id]) {
            // If it exists, increase the quantity
            accumulator[currentItem.id].quantity += currentItem.quantity;
          } else {
            // If it doesn't exist, add the item to the accumulator
            accumulator[currentItem.id] = { ...currentItem };
          }
          return accumulator;
        }, {});
        
        // Consolidate the items, adjusting quantities for duplicates
        membershipBoxData.items = Object.values(collapsedItems);

        const isPropCustomBox = membershipBoxData.items[0].properties.hasOwnProperty('_included_in_custombox') ? 'custom' : 'curated';   
        const validateItems = validatePropertiesCustom(membershipBoxData.items, isPropCustomBox);

        if(!validateItems){
          M.toast({html: 'Items or properties failed to load properly. Please attempt to reload.', classes: 'membershipPopupAlert error'});
          console.error("Validation didn't pass please fix items data: ", membershipBoxData);
          return
        }
    
        // add to cart
        return Promise.all([
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async: false,
            data: membershipBoxData,
            dataType: 'json',
            success:function(data) {
              console.log(':: membership box and prods added to cart ::',{data: data});
              _initPreloader(false);
              _initCloseHelper();
              typeSafetySubscription();
        
              // turn off loaders
              M.toast({html: 'EBY Subscription added to cart!', classes: 'toast ebyAtcAlert success23'});
              window.loadCart();
              vela.RightDrawer.open();
        
              let boxProdObj = data.items.reduce(function(acc,item){if(item.product_type == "Subscription Box"){acc.push(item);}return acc;},[])[0];
  
              _trackFunnelEvent("complete", "sub_funnel_complete__" + boxProdObj.title, data.items);
              
              let subTypeKey = boxProdObj.title.toLowerCase().indexOf('in mixed') >= 0 ? boxProdObj.sku.toLowerCase().slice(0,2) + "_mx" : boxProdObj.sku.toLowerCase().slice(0,2) + "_nu";
              let subPlanKey = _isMissySizeGroup(boxProdObj.variant_title) >= 0 ? boxProdObj.sku.toLowerCase().slice(boxProdObj.sku.length - 2) + "_missy" : boxProdObj.sku.toLowerCase().slice(boxProdObj.sku.length - 2) + "_plus";
              let subTypeQtyKey = subTypeKey + "__qty";
              let subTrackingData = {
                event_label: boxProdObj.sku,
                subscription_plan: subPlanKey,
                subscription_type: subTypeKey,
                subscription_quantity: 1,
                page_location: window.location.pathname, 
                page_title: document.title,
                event_value: parseInt(Shopify.formatMoney(boxProdObj.price))
              };
              subTrackingData[subTypeQtyKey] = 1;
              gtag("event", "add_to_cart__subscription", subTrackingData);
              gtag("event", "curatedBoxAddedToCart", { event_category: "startingPoint-" + window.location.pathname, event_label: "boxContents-", event_value: "", subbox_contents: "", page_location: window.location.pathname, page_title: document.title });
              gtag("event", "add_to_cart", {
                  currency: "USD",
                  value: parseInt(Shopify.formatMoney(boxProdObj.price)),
                  page_location: window.location.pathname, 
                  page_title: document.title,
                  event_label: "atc_type-subbox_curated",
                  event_category: boxProdObj.product_title,
                  items: [
                      {
                          item_id: boxProdObj.product_id,
                          item_name: boxProdObj.product_title,
                          affiliation: "EBY",
                          currency: "USD",
                          index: 0,
                          item_category: boxProdObj.product_type,
                          item_variant: boxProdObj.variant_title,
                          price: parseInt(Shopify.formatMoney(boxProdObj.price)),
                          quantity: 1,
                      },
                  ],
              });
        
              return boxProdObj;
            },
            error: function(xhr, text) {
              console.log("::EbySubscriptionBox addToCart:: FAILURE", {
                text : text,
                xhr : xhr
              });
              if (!!xhr.responseJSON) {
                alert(xhr.responseJSON.description);
              }
        
            }
          })
        ]).catch((error) => {
          console.log('::addClassicPantyBox:: FAILURE', error.message);
        });
  }
  function _initPreloader(toggle) {
      if (!!toggle) {
        jQuery('body').addClass('velaCartAdding');
      } else {
        jQuery('body').removeClass('velaCartAdding');
      }
  }

  function _curateProducts (prdsPossible, prdsAssortment) {
       // console.log(':: prdsPossible ::', prdsPossible);
       let subBoxItems = [],
           sortedOutProducts = [],
           matchingColorKeys = [],
           matchingProductPairs = [];
       // get subscription product
       let subBoxParentItems = prdsPossible.filter((item, index) => {return item['prodType'] == "Subscription Box"});
       let subBoxParentItem = {};
       let chunkSize = 0;
       let typeBraSet = ''; 
       let typeSubBoxChoose = 0;
        
      if (vela.subFour.boxType === "classic_box"){
          switch (vela.subFour.styles){
            case "only_bra":
                subBoxItems = prdsAssortment.reduce((acc, prd) => {
                  if (acc.length > 0) {
                    return acc;
                  }
                  // note - wireless bralettes are not accommdated for
                  let hasStock = prdsPossible.filter((prodWithStockData) => {return prodWithStockData.availQty > 12 && prodWithStockData.prodType === "Only Bra" && prodWithStockData.prodId === prd.id});
                  console.log(prd.title + ' :: ', hasStock);
             
                  if (hasStock.length < 1) {
                    return acc;
                  }
                  
                  acc.push(hasStock[0]);
                  
                  return acc;
                }, []);
                
              break;
            case "sheer_bra":
            case "support_bra":
                subBoxItems = prdsAssortment.reduce((acc, prd) => {
                  if (acc.length > 0) {
                    return acc;
                  }
                  // note - wireless bralettes are not accommdated for
                  let fabricLineRequested = vela.subFour.currentBox.style === "sheer_bra" ? "Mesh Bralette" : "Core Bralette";
                  let hasStock = prdsPossible.filter((prodWithStockData) => {return prodWithStockData.availQty > 12 && prodWithStockData.prodType === fabricLineRequested && prodWithStockData.prodId === prd.id});
                  console.log(prd.title + ' :: ', hasStock);
             
                  if (hasStock.length < 1) {
                    return acc;
                  }
                  
                  acc.push(hasStock[0]);
                  
                  return acc;
                }, []);
              
              break;
            case "custom":
              subBoxItems = vela.subFour.products;
              break;
            default:
              // fc and mx
                let finalonlyAssort = [];
              
                subBoxItems = prdsAssortment.reduce((acc, prd) => {
                  if (acc.length > 2) {
                    return acc;
                  }
                  let hasStock = prdsPossible.filter((prodWithStockData) => {return prodWithStockData.availQty > 3 && prodWithStockData.prodType !== "Subscription Box" && prodWithStockData.prodId === prd.id});
                  console.log(prd.title + ' :: ', hasStock);
             
                  if (hasStock.length < 1) {
                    return acc;
                  }
                  
                  acc.push(hasStock[0]);
                  
                  return acc;
                }, []);

                // add parent sub
                let pantySub = prdsPossible.filter((prd) => {return prd.prodType.indexOf("Subscription Box") >= 0});
                finalonlyAssort.push(pantySub[0]);
                subBoxItems = finalonlyAssort.concat(subBoxItems);
              break;
          }
      } else if (vela.subFour.boxType === "set_box") {
          // capacity: 2
          
          if (vela.subFour.products.some(product => product.productName === 'Relief Bra')) {
            typeBraSet = 'relief_bra';
            typeSubBoxChoose = 7281088823340;
          } else if (vela.subFour.products.some(product => product.productName === 'Support Bra')) {
            typeBraSet = 'support_bra';
            typeSubBoxChoose = 7281088790572;
          } else if (vela.subFour.products.some(product => product.productName === 'Sheer Bra')) {
            typeBraSet = 'sheeer_bra';
            typeSubBoxChoose = 7274930700332;
          } else if (vela.subFour.products.some(product => product.productName === 'Wireless Bra')) {
            typeBraSet = 'wireless_bra';
            typeSubBoxChoose = 7835551891500; // fc 031425
          }  else {
            console.error('No matching bra type was found');
          }
          switch (''){
            case "relief_bra":
              break;
            case "support_bra":
              break;
            case "sheer_bra":
              break;
            default:
              subBoxItems = vela.subFour.products.slice(0,2);
              break;
          }
      } else if (vela.subFour.boxType === "bra_box") {
          // capacity: 1

          switch (vela.subFour.setBraOpt){
            case "only_bra":
              let obSub = prdsPossible.filter((prd) => {return prd.prodType.indexOf("Subscription Box") >= 0 && prd.prodTitle.includes('Only')});
              let ob = prdsPossible.filter((prd) => {return prd.prodType === "Core Bra"}); // products in stock and desired
              let onlybrasCollection = prdsAssortment.slice(3); // remove the first 3 sub products - now its a list of set pairs
              let finalonlybraAssort = [];

              finalonlybraAssort.push(obSub[0]);
              finalonlybraAssort.push(ob[0]);

              subBoxItems = finalonlybraAssort;
            break;
            case "support_bra":

              let spSub = prdsPossible.filter((prd) => {return prd.prodType.indexOf("Subscription Box") >= 0 && prd.prodTitle.includes('Support')});
              let sp = prdsPossible.filter((prd) => {return prd.prodType === "Core Bralette"}); // products in stock and desired
              let supportbrasCollection = prdsAssortment.slice(3); // remove the first 3 sub products - now its a list of set pairs
              let finalsupportbraAssort = [];
              
              console.log(':: only bra box curation, avail ::', {
                spSub,
                sp
              });

              finalsupportbraAssort.push(spSub[0]);
              finalsupportbraAssort.push(sp[0]);

              subBoxItems = finalsupportbraAssort;
              
            break;
            case "sheer_bra":

              let shSub = prdsPossible.filter((prd) => {return prd.prodType.indexOf("Subscription Box") >= 0 && prd.prodTitle.includes('Sheer')});
              let sh = prdsPossible.filter((prd) => {return prd.prodType === "Mesh Bralette"}); // products in stock and desired
              let sheerbrasCollection = prdsAssortment.slice(3); // remove the first 3 sub products - now its a list of set pairs
              let finalsheerbraAssort = [];
              
              console.log(':: sheer bra box curation, avail ::', {
                shSub,
                sh
              });

              finalsheerbraAssort.push(shSub[0]);
              finalsheerbraAssort.push(sh[0]);

              subBoxItems = finalsheerbraAssort;
              
            break;
            case "bra-custom":
              subBoxItems = vela.subFour.products.slice(0,1);
            break;
            default:
              subBoxItems = vela.subFour.products.slice(0,1);
            break;
          }
          
      }
    
      // add in the sub box product
      if (vela.subFour.styles === "custom") {
        subBoxParentItem = subBoxParentItems.filter((item, index) => {return item['prodTitle'].indexOf('Panty') >= 0})[0];
        subBoxItems.unshift(subBoxParentItem);
      } else if (vela.subFour.styles === "bra-custom") {
        subBoxParentItem = subBoxParentItems.filter((item, index) => {return item['prodTitle'].indexOf('Bra') >= 0})[0];
        subBoxItems.unshift(subBoxParentItem);
      } else if (vela.subFour.styles === "set_custom") {
        subBoxParentItem = subBoxParentItems.filter((item, index) => {return item['prodId'] === typeSubBoxChoose})[0];
        subBoxItems.unshift(subBoxParentItem);
      } else {
        // do nothing since the parent is already there
        // subBoxParentItem = subBoxParentItems[0];
      }
    
      
      return subBoxItems;
      
    }

  function _getSortedCollectionByStock(stockLib, prdLib) {
      let self = this,
          SWH = "46033961004", // use sub wh
          ECWH = "46033928236"; // use ecomm wh

      // if this is a custom box pull, get from ECWH
       if (vela.subFour.styles.indexOf("custom") >= 0) {
         let stockProdLibrary = stockLib.reduce(function (acc, stockData) {
            if (stockData.location_id === +ECWH) {
              //console.log(':: inventory found ::', stockData.inventory_item_id);
              acc[stockData.inventory_item_id] = stockData.available;
            }
            return acc;
          }, {});
      
          return prdLib.map(function (prd, index) {
            prd.availQty = stockProdLibrary[prd.inventory_item_id];
            return prd;
          });
       } else {
         let stockProdLibrary = stockLib.reduce(function (acc, stockData) {
            if (stockData.location_id === +SWH) {
              //console.log(':: inventory found ::', stockData.inventory_item_id);
              acc[stockData.inventory_item_id] = stockData.available;
            }
            return acc;
          }, {});
      
          return prdLib.map(function (prd, index) {
            prd.availQty = stockProdLibrary[prd.inventory_item_id];
            return prd;
          });
       }
  }

  /*
    ****************************************************************
    * Description: Track major interations in the subscription 4.0 funnel
    * @request(str)    => type of funnel event or general event
    * @eventName (str) => event name to look up in GA4 [sub_funnel_open, sub_funnel_close, sub_funnel_complete]
    * @eventDataAvail (obj) => store state + form data at the time for eventLabel and eventCategory for example
    ****************************************************************
  */
  function _trackFunnelEvent (request, eventName, eventDataAvail = {}) {
      console.log(":: trackFunnelEvent :: fire", {request: request, eventName: eventName, eventDataAvail: eventDataAvail});
      let currentBox = !!eventDataAvail.boxType ? eventDataAvail.boxType : "empty";
      
      switch (request) {
          case "open":
            gtag("event", "sub_funnel_v4__open", { 
              event_category: "open_screen-" + eventName.split('__')[1], 
              event_label: "curr_page-" + window.location.pathname, 
              event_value: "",
              current_box: currentBox
            });
            break;
          case "close":
            gtag("event", "sub_funnel_v4__close", { 
              event_category: "close_screen-" + eventName.split('__')[1], 
              event_label: "curr_page-" + window.location.pathname, 
              event_value: "",
              current_box: currentBox
            });
            break;
          case "step":
          case "next":
            if (eventDataAvail.stepsVisited.length === 1) {
              return;
            }
            let completedScreen = eventDataAvail.stepsVisited[eventDataAvail.stepsVisited.length - 2];
            let selectedValue = "";
            if (completedScreen.indexOf('plan') >= "0") {
              selectedValue = eventDataAvail.boxType;
            }
            if (completedScreen.indexOf('color') >= "0") {
              selectedValue = eventDataAvail.colors;
            }
            if (completedScreen.indexOf('size') >= "0") {
              let ps = !!eventDataAvail.sizes.panty ? eventDataAvail.sizes.panty : "";
              let bs = !!eventDataAvail.sizes.braCup ? eventDataAvail.sizes.braSizeChar + "_" + eventDataAvail.sizes.braCup + eventDataAvail.sizes.braMeasure : "";
              selectedValue = ps !== "" & bs !== "" ? ps + ", " +  bs : ps + bs;
            }
            if (completedScreen.indexOf('style') >= "0") {
              selectedValue = eventDataAvail.styles;
            }
            gtag("event", "sub_funnel_v4__step", { 
              event_category: "selected-" + selectedValue, 
              event_label: "screen_completed-" + completedScreen, 
              event_value: "",
              current_box: currentBox
            });
            break;
          case "complete":
            gtag("event", "sub_funnel_v4__complete", { 
              event_category: "box_added-" + eventName.split('__')[1], 
              event_label: "curr_page-" + window.location.pathname, 
              event_value: ""
            });
            break;
      }
  }

  function _cleanData(rawData) {
      console.log('::ControllerFunnelCartData:: cleanData, rawData', rawData);
      let cleanBoxData = Object.keys(rawData).reduce((acc, key) => { acc[key.split('-')[1]] = rawData[key]; return acc;}, {});
      //vela.msb = vela.msb || new EbySubscriptionBoxToAdd(cleanBoxData);

      cleanBoxData.styleGroup = cleanBoxData.styleGroup || cleanBoxData['styleGroup_panty'];
      // find the value of the given membership box
      switch (cleanBoxData.styleGroup) {
        case "only_bra":
          vela.msb.opts.styleGroupKey = "1o";
          break;
        case "support_bra":
        case "sheer_bra":
          vela.msb.opts.styleGroupKey = "1b";
          break;
        case "mixed":
          vela.msb.opts.styleGroupKey = "mx";
          break;
        case "full_coverage":
          vela.msb.opts.styleGroupKey = "fc";
          break;
        case "all_highwaisted":
          vela.msb.opts.styleGroupKey = "hw";
          break;
        case "all_thongs":
          vela.msb.opts.styleGroupKey = "at";
          break;
        case "all_briefs":
          vela.msb.opts.styleGroupKey = "ab";
          break;
        case "custom":
          vela.msb.opts.styleGroupKey = "cu";
          break;
      }
      switch (cleanBoxData.colorGroup) {
        case "mixed_bold":
        case "mixed_sophisticated":
        case "mixed_spicy":
          vela.msb.opts.colorGroupKey = "mx";
          break;
        case "neutrals":
          vela.msb.opts.colorGroupKey = "nu";
          break;
      }
      if (cleanBoxData.boxGroup === "classic_box") {
          
          if (cleanBoxData.styleGroup == "only_bra") {
            // this is the only bra box
            vela.msb.opts.boxGroupKey = "cc:1o";
            cleanBoxData['brasizeGroup'] = braCupSizeToChars(cleanBoxData['brasizeGroup__band_sizes'], cleanBoxData['brasizeGroup__cup_sizes']);
            cleanBoxData['pantysizeGroup'] = "xs";
          } else if (cleanBoxData.styleGroup == "support_bra" || cleanBoxData.styleGroup == "sheer_bra") {
            vela.msb.opts.boxGroupKey = "cc:1b";
            cleanBoxData['brasizeGroup'] = braCupSizeToChars(cleanBoxData['brasizeGroup__band_sizes'], cleanBoxData['brasizeGroup__cup_sizes']);
            cleanBoxData['pantysizeGroup'] = "xs";
          } else if (cleanBoxData.styleGroup == "custom") {
            // this is the custom box
            vela.msb.opts.boxGroupKey = "cc:cu";
            vela.msb.opts.colorGroupKey = "mx";
            cleanBoxData['brasizeGroup']  = "xs";
          } else if (cleanBoxData.styleGroup == "mixed") {
            // this is the custom box
            vela.msb.opts.boxGroupKey = "cc:mx";
            cleanBoxData['brasizeGroup']  = "xs";
          } else {
            // this is the panty box
            vela.msb.opts.boxGroupKey = "cc:fc";
            cleanBoxData['brasizeGroup']  = "xs";
          }
      } else if (cleanBoxData.boxGroup === "set_box") {
          cleanBoxData['brasizeGroup'] = braCupSizeToChars(cleanBoxData['brasizeGroup__band_sizes'], cleanBoxData['brasizeGroup__cup_sizes']); 
          if (cleanBoxData['styleGroup_bra'] == "only_bra") {
            // this is the only bra box
            vela.msb.opts.boxGroupKey = "ss:1o";
          } else if (cleanBoxData['styleGroup_bra'] == "support_bra" || cleanBoxData['styleGroup_bra'] == "sheer_bra") {
            vela.msb.opts.boxGroupKey = "ss:1b";
          } else {
            // this is the panty box
            vela.msb.opts.boxGroupKey = "ss:mx";
          }
          vela.msb.opts.styleGroupKey = cleanBoxData['styleGroup_panty'] === "full_coverage" ? "fc" : "mx";
      } else {
          cleanBoxData['brasizeGroup'] = braCupSizeToChars(cleanBoxData['brasizeGroup__band_sizes'], cleanBoxData['brasizeGroup__cup_sizes']);
          if (cleanBoxData['styleGroup_bra'] == "only_bra") {
            // this is the only bra box
            vela.msb.opts.boxGroupKey = "pm:2o";
          } else if (cleanBoxData['styleGroup_bra'] == "support_bra" || cleanBoxData['styleGroup_bra'] == "sheer_bra") {
            vela.msb.opts.boxGroupKey = "pm:2b";
          } else {
            // this is the panty box
            vela.msb.opts.boxGroupKey = "pm:mx";
          }
          vela.msb.opts.styleGroupKey = cleanBoxData['styleGroup_panty'] === "full_coverage" ? "fc" : "mx";
      }
      
      return cleanBoxData;
    }

  // return a Promise for curated boxes
  function _getProducts (boxData) {
      var self = this;
      let dataPayload = boxData;
      
      if (!!dataPayload) {

        let membershipKey = "";
        if (dataPayload.boxType === "classic_box" && dataPayload.styles.indexOf("custom") < 0) {
          membershipKey = "cc-" + dataPayload.setPantyOpt + "-" + dataPayload.currentBox.color;
        } else if (dataPayload.boxType === "classic_box" && dataPayload.styles.indexOf("custom") >= 0) {
          membershipKey = "cc-cu-mx";
        } else if (dataPayload.boxType === "bra_box" && dataPayload.styles.indexOf("custom") < 0) {
          membershipKey = "cc-1b" + "-" + dataPayload.currentBox.color;
        } else if (dataPayload.boxType === "bra_box" && dataPayload.styles.indexOf("custom") >= 0) {
          membershipKey = "cc-cu-mx";
        } else if (dataPayload.boxType === "set_box" && dataPayload.styles.indexOf("custom") < 0) {
          membershipKey = "ss-" + dataPayload.setPantyOpt + "-" + dataPayload.currentBox.color;
        } else if (dataPayload.boxType === "set_box" && dataPayload.styles.indexOf("custom") >= 0) {
          membershipKey = "cc-cu-mx";
        } else {
          console.log(':: key unknown ::');
          membershipKey = vela.msb.opts.boxGroupKey.split(":")[0] + "-" + vela.msb.opts.boxGroupKey.split(":")[1] + "-" + dataPayload.styles;
        }
        //console.log(":: init pullFirstBoxMembership::", membershipKey);

        if (boxData.styles.indexOf("custom") >= 0 ) {
          
            // make api request to get products in my size and ready them for my cart
            let braSizeTemp = !!dataPayload['sizes']['braSizeChar'] ? dataPayload['sizes']['braSizeChar'] : "xs";
            let pantySizeTemp = !!dataPayload['sizes']['panty'] ? dataPayload['sizes']['panty'] : "xs";
            let sizesKeyToCheck = pantySizeTemp + "::" + braSizeTemp + "::xs";
            // console.log(':: sizesKeyToCheck ::', sizesKeyToCheck);
            let isSetCollectionId = 0;
            let typeFileSubs = "";

            if(boxData.styles.indexOf("set_custom") >= 0 ){
              isSetCollectionId = 324702601260;
              typeFileSubs = "eby-customSubs_set_v2b.php";
            } else {
              isSetCollectionId = 302265532460;
              typeFileSubs = "eby-customSubsv1.php";
            }
          
            return Promise.all([
              jQuery.ajax({
                type: "POST",
                crossDomain : true,
                url: window.APIDomain+window.otherAPI+typeFileSubs, 
                data: { data: {
                  "variantOptsVals": sizesKeyToCheck,
                  "collectionId": isSetCollectionId,
                  "warehouseKey" : "ecomm"
                }},
                beforeSend: function() {
                    //_initPreloader(true);
                },
                dataType: 'json',
                headers: {
                    'Authorization': 'Bearer ddd345d2498c7717a7bbbe86d9d145dc',
                    'Access-Control-Allow-Origin': '*'
                },
                success: function(data){
                  console.log("::stockcheck success::", data);
                  //_initPreloader(false);
  
                  if(!!data){
                    // combine data into one pool
                    let stockProdLibrary = _getSortedCollectionByStock(
                      data.inventoryHealthcheck,
                      data.prodInventoryData
                    );
  
                    //M.toast({html: 'Your new box is ready!', classes: 'membershipPopupAlert success'});
                    return stockProdLibrary;
                  }
                },
                error: function(xhr, text) {
                  console.log("::stockcheck failure::", {text : text,xhr : xhr});
                  // box is out of stock
                  _initPreloader(false);
                  M.toast({html: 'Subscription could not be loaded. Please try again.', classes: 'membershipPopupAlert error'});
                }
              })
            ]);
          
        } else {
          // get products for new box
          return Promise.all([
            jQuery.getJSON('https://shop.join-eby.com/collections/first-box-'+membershipKey+'-assortment.json', function(data) {
              console.log(":: collection id pulled ::", data);
              
              if (!!data.collection) {
                  return data;
              } else {
                console.log( ":: stock pull data missing ::", data);
              }
            })
            .fail(function(error) {
              console.log( ":: stock api pull :: FAILURE ::", error.message);
            })
          ])
          .then((response) => {
            // make api request to get products in my size and ready them for my cart
            let braSizeTemp = !!dataPayload['sizes']['braSizeChar'] ? dataPayload['sizes']['braSizeChar'] : "xs";
            let pantySizeTemp = !!dataPayload['sizes']['panty'] ? dataPayload['sizes']['panty'] : "xs";
            let sizesKeyToCheck = pantySizeTemp + "::" + braSizeTemp + "::xs";
            console.log(':: sizesKeyToCheck ::', sizesKeyToCheck);
            
            return Promise.all([
              jQuery.ajax({
                type: "POST",
                crossDomain : true,
                url: window.APIDomain+window.otherAPI+"eby-coreHelperSubscription.php",
                data: { data: {
                  "variantOptsVals": sizesKeyToCheck,
                  "collectionId": response[0].collection.id,
                  "warehouseKey" : "sub"
                }},
                beforeSend: function() {
                    _initPreloader(true);
                },
                dataType: 'json',
                headers: {
                    'Authorization': 'Bearer ddd345d2498c7717a7bbbe86d9d145dc',
                    'Access-Control-Allow-Origin': '*'
                },
                success: function(data){
                  console.log("::stockcheck success::", data);
                  _initPreloader(false);
  
                  if(!!data){
                    // combine data into one pool
                    let stockProdLibrary = _getSortedCollectionByStock(
                      data.inventoryHealthcheck,
                      data.prodInventoryData
                    );
  
                    //M.toast({html: 'Your new box is ready!', classes: 'membershipPopupAlert success'});
                    return stockProdLibrary;
                  }
                },
                error: function(xhr, text) {
                  console.log("::stockcheck failure::", {text : text,xhr : xhr});
                  // box is out of stock
                  _initPreloader(false);
                  M.toast({html: 'Subscription could not be loaded. Please try again.', classes: 'membershipPopupAlert error'});
                }
              })
            ]);
          })
          .catch(function (data) {
            console.log(":: curation promise pull :: FAILURE", data);
          });
        }
      }
  }
  
  (function(){
    // Flag to indicate if the listeners have been set.
    let listenersAttached = false;

    const initSubButton = document.querySelector('[data-rid="2720f289-7fc8-4412-b5c9-d93e95a7137a"]');
    const initSubWrapper = document.getElementById('subsc40-wrapper');
    const initSubForm = document.getElementById("esbta-new_box_form");
    const initSubSubmitButton = document.getElementById("submitSubscription4");
    // const initBottomElem = document.querySelectorAll('.subsFourCtaExtrBttns');

    // List of data-rid values
    const dataRidValues = [
        "40516799-f32a-4f46-bdbb-7c6b1048f056",
        "9bee1a8d-b7c5-4dda-8dc8-a83263ea40b1",
        "a5005e9a-d16f-46e4-889e-68e0ef89810a",
        "38a7d35a-6ae4-44c4-93b2-8f75fa7afa27"
    ];
    // Build the selector string to match all buttons with specified data-rid values
    const selector = dataRidValues.map(rid => `[data-rid="${rid}"]`).join(',');

    // Get all elements that match the selector
    const initBottomElem = document.querySelectorAll(selector);
    
    if(initSubButton){
      initSubButton.addEventListener('click', (event) => {
        event.preventDefault();
        initSubWrapper.style.display = 'block';

        // Only run mainSubscriptionFunnel if listeners haven't been attached yet.
        const flowMain = mainSubscriptionFunnel('', listenersAttached);
        MetricsMainFunnel.openFunnel('CTA_Hero');

        if(!listenersAttached){
          flowMain.setupSteps();
          listenersAttached = true;
        }
      }, false);

      initSubForm.addEventListener("submit", function(event){
        event.preventDefault();
        // Your code here, e.g., AJAX call to submit form data.
      });

      initSubSubmitButton.addEventListener("click", function(event){
        event.preventDefault();
        let currentBox = vela.subFour;
        console.log('::event for add_to_cart::', {
          btn: event.target,
          boxInState: currentBox
        });

        // ToDo: has to be final product data from the shopify collection for its respective box
        // step 1 - get collection id by key, pull collection of products, and check stock
        // step 2 - create properties and add products to cart
        // fc-mx -> [{}, {}, {}]
        addBoxToCart(currentBox);
      });

      if(initBottomElem){
        
        initBottomElem.forEach((el, index) => {
          el.addEventListener('click', (event) => {

            event.preventDefault();
            initSubWrapper.style.display = 'block';

            // Only run mainSubscriptionFunnel if listeners haven't been attached yet.
            const flowMain = mainSubscriptionFunnel('', listenersAttached);
            MetricsMainFunnel.openFunnel(`CTA_BelowFold_${index}`, '');
        
            if(!listenersAttached){
              flowMain.setupSteps();
              listenersAttached = true;
            }
          });
        })
      }
    }

    const isCardMobile = (indexCart) => indexCart < 1 ? 'mobile' : 'desktop';

    document.querySelectorAll('.handlerNewFunnelEventClassic').forEach((deskFunnel,index) => {
      deskFunnel.addEventListener('click', () => {
        document.getElementById('subsc40-wrapper').style.display = 'block';
        
        const flowMain = mainSubscriptionFunnel('classic', listenersAttached);
        flowMain.handleLandingPage('eby-sub4-plan', 'subs-plan-001');
        MetricsMainFunnel.openFunnel(`CTA_BelowFold_${isCardMobile(index)}`, 'classic_box');
        
        if(!listenersAttached){
          flowMain.setupSteps();
          listenersAttached = true;
        }
      });
    })
    document.querySelectorAll('.handlerNewFunnelEventBra').forEach((deskFunnel, index) => {
      deskFunnel.addEventListener('click', () => {
        document.getElementById('subsc40-wrapper').style.display = 'block';
        
        const flowMain = mainSubscriptionFunnel('setsPlan', listenersAttached);
        flowMain.handleLandingPage('eby-sub4-plan', 'eby-sub4-style-panty-bra-only');
        MetricsMainFunnel.openFunnel(`CTA_BelowFold_${isCardMobile(index)}`, 'bra_box');

        if(!listenersAttached){
          flowMain.setupSteps();
          listenersAttached = true;
        }
      });
    })
    document.querySelectorAll('.handlerNewFunnelEventSet').forEach((deskFunnel, index) => {
      deskFunnel.addEventListener('click', () => {
        document.getElementById('subsc40-wrapper').style.display = 'block';

        const flowMain = mainSubscriptionFunnel('premiumPlan', listenersAttached);
        flowMain.handleLandingPage('eby-sub4-plan', 'eby-sub4-size-panty-bra');
        MetricsMainFunnel.openFunnel(`CTA_BelowFold_${isCardMobile(index)}`, 'set_box');
        
        if(!listenersAttached){
          flowMain.setupSteps();
          listenersAttached = true;
        }
      });
    })
    
    typeSafetySubscription();

    function hideCtasSubsLanding(type){

        // List of data-rid values
        const dataRidValues = [
            "40516799-f32a-4f46-bdbb-7c6b1048f056",
            "9bee1a8d-b7c5-4dda-8dc8-a83263ea40b1",
            "a5005e9a-d16f-46e4-889e-68e0ef89810a",
            "38a7d35a-6ae4-44c4-93b2-8f75fa7afa27"
        ];
        // Build the selector string to match all buttons with specified data-rid values
        const selectorCTasNew = dataRidValues.map(rid => `[data-rid="${rid}"]`).join(',');
    
        // Get all elements that match the selectorCTasNew
        const initBottomElem = document.querySelectorAll(selectorCTasNew);

        const initSubButton = document.querySelector('[data-rid="2720f289-7fc8-4412-b5c9-d93e95a7137a"]');
        // const initBottomElem = document.querySelectorAll('.subsFourCtaExtrBttns');
        const landingFunnelClassic = document.querySelectorAll('.handlerNewFunnelEventClassic');
        const landingFunnelSet = document.querySelectorAll('.handlerNewFunnelEventSet');
        const landingFunnelBra = document.querySelectorAll('.handlerNewFunnelEventBra');
        const landingTilePanty = document.querySelector('.eby-membership-button-flow4-funnel.eby-bkgrn-uniqe-pink');
        
        if (type === 'show') {
            if (initSubButton) {
                initSubButton.classList.remove('subsActive');
                // initSubButton.innerHTML = 'UNLOCK 50% OFF'; // Text when the subscription is not active
                initSubButton.style.display = "block"; //.classList.remove('ebySubsMainUnclickable')
            }
            if (initBottomElem) {
                initBottomElem.forEach(el => {
                    el.classList.remove('subsActive');
                    // el.innerHTML = 'UNLOCK 50% OFF'; // Update the text for all related buttons
                    el.style.display = "block"; //remove('ebySubsMainUnclickable')
                });
            }
            if (landingTilePanty) {
                landingTilePanty.classList.remove('subsActive');
                landingTilePanty.innerHTML = 'UNLOCK 50% OFF'; // Text when the subscription is not active
            }
            if (landingFunnelClassic && landingFunnelSet && landingFunnelBra) {  
                landingFunnelClassic.forEach(el => el.classList.remove('ebySubsMainUnclickable'));
                landingFunnelSet.forEach(el => el.classList.remove('ebySubsMainUnclickable'));
                landingFunnelBra.forEach(el => el.classList.remove('ebySubsMainUnclickable'));
            }
        } else {
            if (initSubButton) {
                initSubButton.classList.add('subsActive');
                //initSubButton.innerHTML = 'Your subscription awaits! Finalize it in checkout.'; // New text for active subscription
                initSubButton.style.display = "none" //.classList.add('ebySubsMainUnclickable');
            }
            if (landingTilePanty) {
                landingTilePanty.classList.add('subsActive');
                landingTilePanty.innerHTML = 'Your subscription awaits! Finalize it in checkout.'; // New text for active subscription
            }
            if (initBottomElem) {
                initBottomElem.forEach(el => {
                    el.classList.add('subsActive');
                    //el.innerHTML = 'Your subscription awaits! Finalize it in checkout.'; // Update the text for all related buttons
                    el.style.display = "none" //.classList.add('ebySubsMainUnclickable');
                });
            }
            if (landingFunnelClassic && landingFunnelSet && landingFunnelBra) {  
                landingFunnelClassic.forEach(el => el.classList.add('ebySubsMainUnclickable'));
                landingFunnelSet.forEach(el => el.classList.add('ebySubsMainUnclickable'));
                landingFunnelBra.forEach(el => el.classList.add('ebySubsMainUnclickable'));
            }
        }
      }
        //Get the latest cart object to check if there is a subscription product
        async function typeSafetySubscription(){
        let hasSubscriptionProduct = false;

        await $.getJSON('/cart.json')
            .then(cart => {
                // Check if any of the products in the cart have a type of "Main Subscription" or "Subscription Box"
                hasSubscriptionProduct = cart.items.some(item => {
                  const productType = item.product_type;
                  return productType === 'Main Subscription' || productType === 'Subscription Box';
                });

                if(hasSubscriptionProduct){
                  hideCtasSubsLanding(); 
                } else {
                  hideCtasSubsLanding('show'); 
                }
              })
          .catch(error => {
          console.error(error);
          });
        } 
  })();